import { Card, Flex, Typography } from 'antd'
import formatAmount from 'shared/helpers/formatAmount'
import formatDate from 'shared/helpers/formatDate'
import resolveInvoiceTotals from 'features/invoices/helpers/resolveInvoiceTotals'
import isOverdue from 'features/invoices/helpers/isOverdue'
import { Invoice } from 'types'
import { NOT_AVAILABLE } from 'constants/display'
import { DATE_API_FORMAT } from 'constants/dates'
import dayjs from 'dayjs'

interface InvoiceHeaderProps {
  invoice: Invoice
}

const InvoiceHeader = ({ invoice }: InvoiceHeaderProps) => {
  const { total, tax } = resolveInvoiceTotals(invoice.total, invoice.tax, invoice.invoice_lines)

  return (
    <Card>
      <Flex justify="space-between" align="flex-start" gap="1rem">
        <div>
          <Typography.Text type="secondary" className="invoice-header-label small text-uppercase">
            Invoice
          </Typography.Text>
          <Typography.Text className="invoice-header-id d-block fw-semibold fs-4 mt-1 mb-2">
            #{invoice.id}
          </Typography.Text>
        </div>
        <Flex vertical align="flex-end">
          <Typography.Text type="secondary" className="invoice-header-label small text-uppercase">
            Total incl. tax
          </Typography.Text>
          <Typography.Text className="invoice-header-total d-block fw-semibold fs-2 mt-1">
            {formatAmount(Number(total))}
          </Typography.Text>
          <Typography.Text type="secondary">
            Tax: {formatAmount(Number(tax))}
          </Typography.Text>
        </Flex>
      </Flex>
      <Flex gap="2rem" className="border-top mt-3 pt-3">
        <div>
          <Typography.Text type="secondary">Issued </Typography.Text>
          <Typography.Text strong>{invoice.date ? formatDate(invoice.date) : NOT_AVAILABLE}</Typography.Text>
        </div>
        <div>
          <Typography.Text type="secondary">Due </Typography.Text>
          <Typography.Text type={isOverdue(invoice, dayjs().format(DATE_API_FORMAT)) ? 'danger' : undefined} strong>
            {invoice.deadline ? formatDate(invoice.deadline) : NOT_AVAILABLE}
          </Typography.Text>
        </div>
      </Flex>
    </Card>
  )
}

export default InvoiceHeader
